export default __webpack_public_path__ + "static/media/Logo.c71d0aa4.jpg";